/**
 * Modal shown after a successful second-pass submit when every dimension
 * matched the first annotator — per `feature-spec.md` §3.4.7.
 *
 * Composition mirrors `CreateCollectionModal`: controlled `open` +
 * `onOpenChange`, single primary CTA in the `DialogFooter`. Outside-click
 * / X dismissal is treated as "Continue" by the parent (it just navigates
 * back to the queue).
 */
import React from 'react';

import { Button } from '../../../../../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../../../../ui/dialog';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  agreedCount: number;
  totalDimensions: number;
  onContinue: () => void;
}

const AgreementModal: React.FC<Props> = ({
  open,
  onOpenChange,
  agreedCount,
  totalDimensions,
  onContinue,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="agreement-modal">
      <DialogHeader>
        <DialogTitle>Annotators agree</DialogTitle>
        <DialogDescription>
          {agreedCount}/{totalDimensions} dimensions agreed — sent to the Review queue for manager sign-off.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button onClick={onContinue} data-testid="agreement-continue">
          Continue
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default AgreementModal;
